import moment from 'moment';

window.Vue = require('vue');
import route from 'ziggy';

import { Ziggy } from './ziggy';
import store from './store';
import Lang from 'lang.js';
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import Inputmask from 'inputmask';
import vSelect from 'vue-select';
import Notifications from 'vue-notification';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.directive('input-mask', {
  bind: function (el) {
    new Inputmask().mask(el);
  },
});

Vue.directive('click-of-drag', {
  bind: function (el, binding) {
    el.addEventListener('touchstart', (event) => {
      el.touchDragDistanceStart = {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY,
      };
      el.touchDragDistanceEnd = {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY,
      };
    });
    el.addEventListener('touchmove', (event) => {
      el.touchDragDistanceEnd = {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY,
      };
    });
    el.addEventListener('touchend', (event) => {
      const dX = (el.touchDragDistanceEnd.x - el.touchDragDistanceStart.x);
      const dY = (el.touchDragDistanceEnd.y - el.touchDragDistanceStart.y);
      const distance = Math.sqrt(dY * dY + dX * dX);

      if (distance < 5) {
        binding.value(binding.arg);
      }
    });
  },
  inserted: function (el) {
  },
  update: function (el) {
  }
});


// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;
const messages = window.messages;

Vue.prototype.trans = new Lang({
  messages,
  locale: default_locale,
  fallback: fallback_locale
});

// load global config
Vue.prototype.globals = window.globals;

// VeeValidate translations
loadLocale(default_locale);

Vue.use(Notifications);
Vue.use(VueRouter);

// const router = require('./router').default;

Vue.filter('de_date', function (value) {
  return moment(value).format('DD/MM/YYYY');
});

Vue.filter('de_date_dot', function (value) {
  return moment(value).format('DD.MM.YYYY');
});

Vue.filter('de_date_time', function (value) {
  return moment(value).format('DD/MM/YYYY hh:mm');
});

Vue.filter('date_time', function (value) {
  return moment(value).format('YYYY-MM-DD, hh:mm');
});
// /**
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
//  */
//
// const files = require.context('./components', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


Vue.mixin({
  methods: {
    zRoute: (name, params, absolute) => route(name, params, absolute, Ziggy),
  }
});

window.eventHub = new Vue();
Vue.prototype.$eventHub = window.eventHub; // Global event bus


function loadLocale(code) {
  return import(/* webpackChunkName: "js/vee-validate-locale/" */ `./vee-validate/locale/${code}.json`).then(locale => {
    localize(code, locale);
  });
}

export {
  store,
  default_locale,
  // router,
};
